// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store/index'
import vueMoment from 'vue-moment'
import './plugins/veevalidate';
import VueKonva from 'vue-konva';

import './plugins/axios';

import commons from '@/components/commons/axiosCommons'
import './assets/autoDictionary/jquery-1.11.2';

import './plugins/filters';
import EmptyCheck from './plugins/globalFunc';

Vue.config.productionTip = false

Vue.use(vueMoment);
Vue.use(EmptyCheck);
Vue.use(VueKonva);
Vue.mixin(commons);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js